import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import HowItWorks from "./components/HowItWorks";
import WasteTypes from "./components/WasteTypes";
import AcceptableItems from "./components/AcceptableItems";
import ServiceAreas from "./components/ServiceAreas";
import ForAnyProject from "./components/ForAnyProject";
import FAQ from "./components/FAQ";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import ServicesPage from "./components/ServicesPage";
import ServicePage from "./components/ServicePage";
import ServicesShowcase from "./components/ServicesShowcase";

// Home Page Component
const HomePage = () => {
  return (
    <>
      <Hero />
      <About />
      <HowItWorks />
      <WasteTypes />
      <AcceptableItems />
      <ForAnyProject />
      <ServiceAreas />
      <ServicesShowcase />
      <CTA />
      <FAQ />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:slug" element={<ServicePage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
